import type { TokenResponse } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import React from 'react';

import type { TxKeyPath } from '@/core';
import { Button } from '@/ui';
import { Google } from '@/ui/icons/google';

interface GoogleLoginProps {
  onSuccess: (credential: string) => void;
  tx: TxKeyPath;
  onPress?: () => void;
}

export const GoogleLogin = ({ onSuccess, tx, onPress }: GoogleLoginProps) => {
  const handleGoogleSignin = useGoogleLogin({
    onSuccess: (tokenResponse: TokenResponse) => {
      onSuccess(tokenResponse.access_token);
    },
  });

  return (
    <Button
      leftIcon={<Google width="20" height="20" />}
      tx={tx}
      type="secondary"
      style={{ width: '100%' }}
      onPress={() => {
        onPress?.();
        handleGoogleSignin();
      }}
    />
  );
};
